'use strict';

const $ = jQuery.noConflict();

$(function() {
	const stepsBlock = {
		init: function() {
			this.cacheDOM();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$sections = $('.js-steps-block');
		},

		bindEvents: function() {
			if (!this.$sections.length) return;
			this.initLineAnimation();
		},

		initLineAnimation: function() {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;

					const clipRect = entry.target.querySelector('.steps-block__line-clip');

					if (clipRect) {
						clipRect.style.width = '1027';
					}

					observer.unobserve(entry.target);
				});
			}, {threshold: 0.25});

			this.$sections.each(function() {
				observer.observe(this);
			});
		},
	};

	stepsBlock.init();
});
